import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { TransformerParametersViewModel } from './transformerParametersViewModel';
import { SortInfo } from 'src/app/domainObjects/sortInfo';
import { IncludeInfo } from 'src/app/domainObjects/includeInfo';
import { SortBuilderComponent } from '../../sort-builder/sort-builder.component';
import { IncludeBuilderComponent } from '../../include-builder/include-builder.component';
import { FormBuilder, FormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { ErrorReportingService } from 'src/app/services/errorReporting/error-reporting.service';
import { MatDialog } from '@angular/material/dialog';
import { BaseComponent } from 'src/app/base/base.component';
import { UserDataService } from 'src/app/services/user-data-service';
import { ParameterSetting } from 'src/app/domainObjects/masterConfig';
import { OptionItem, OptionItemDataType } from 'src/app/model/optionItem';
import { TransformType } from 'src/app/domainObjects/transformType';

@Component({
    selector: 'app-transformer-parameters',
    templateUrl: './transformer-parameters.component.html',
    styleUrls: ['./transformer-parameters.component.css'],
    standalone: false
})
export class TransformerParametersComponent extends BaseComponent{
  form: FormGroup;
  @Output() formStatus = new EventEmitter<boolean>();
  @Output() SetDefaultRule = new EventEmitter<string>();
  @Output() ToggleRulesColumnDisplay = new EventEmitter<void>();
  @Input() viewModel: TransformerParametersViewModel;
  @Input() sourceColumns:  OptionItemDataType[];
  @Output() eventTimeColumn = new EventEmitter();

  constructor(
    errorService: ErrorReportingService,
    matDialog: MatDialog,private formBuilder: FormBuilder,private userData: UserDataService) {
  super(errorService, matDialog);
  }

  sortCtrl = new UntypedFormControl('');
  includeCtrl = new UntypedFormControl('');
  sourceColumn:ParameterSetting=new ParameterSetting();
  targetColumn:ParameterSetting=new ParameterSetting();
  userColumn: ParameterSetting=new ParameterSetting();
  timeColumn: ParameterSetting=new ParameterSetting();
  sortInfo: ParameterSetting=new ParameterSetting();
  includeInResults: ParameterSetting=new ParameterSetting();
  sampleStart: ParameterSetting=new ParameterSetting();
  sampleEnd: ParameterSetting=new ParameterSetting();
  runAll: ParameterSetting=new ParameterSetting();
  deleteMisses: ParameterSetting=new ParameterSetting();
  missName: ParameterSetting=new ParameterSetting();
  ngOnInit(): void {
    const selectedNode=this.userData.getSelectedNodeDetails();
    const selectedTransform=this.userData.getSelectedTransform()
    const masterconfig=this.userData.getMasterTransformers().find(x=>x.id==selectedTransform.type);
    var parameters=masterconfig.parameters.find(x=>x.farmtypeid==selectedNode.farmtypeid);
    var params:ParameterSetting[]=[];
    if(parameters){
      params=parameters.parameters;
      this.sourceColumn=params.find(x=>x.jsonobject=='defSourceField' && x.iscommonparam==true);
      this.targetColumn=params.find(x=>x.jsonobject=='defTargetField' && x.iscommonparam==true);
      this.userColumn=params.find(x=>x.jsonobject=='userIdField' && x.iscommonparam==true);
      this.timeColumn=params.find(x=>x.jsonobject=='timestampField');
      this.sortInfo=params.find(x=>x.jsonobject=='sortBy');
      this.includeInResults=params.find(x=>x.jsonobject=='includeInResults' && x.iscommonparam==true);
      this.sampleStart=params.find(x=>x.jsonobject=='sampleStart' && x.iscommonparam==true);
      this.sampleEnd=params.find(x=>x.jsonobject=='sampleEnd' && x.iscommonparam==true);
      this.runAll=params.find(x=>x.jsonobject=='runAll' && x.iscommonparam==true);
      this.deleteMisses=params.find(x=>x.jsonobject=='deleteMisses' && x.iscommonparam==true);
      this.missName=params.find(x=>x.jsonobject=='missName' && x.iscommonparam==true);
    }else{
      this.sourceColumn.label="Default Source Field";this.sourceColumn.jsonobject="defSourceField";
      params.push(this.sourceColumn);
      this.targetColumn.label="Default Target Field";this.targetColumn.jsonobject="defTargetField";
      params.push(this.targetColumn);
      this.userColumn.label="User Field";this.userColumn.jsonobject="userIdField";
      params.push(this.userColumn);
      this.timeColumn.label="Timestamp Field";this.timeColumn.jsonobject="timestampField";
      params.push(this.timeColumn);
      this.sortInfo.label="Sort By";this.sortInfo.jsonobject="sortBy";
      this.viewModel.sortInfo=[];//to work sortInfo initialize it
      params.push(this.sortInfo);
      this.includeInResults.label="Include in Results";this.includeInResults.jsonobject="includeInResults";
      params.push(this.includeInResults);
      this.sampleStart.label="Sample Start";this.sampleStart.jsonobject="sampleStart";
      params.push(this.sampleStart);
      this.sampleEnd.label="Sample End";this.sampleEnd.jsonobject="sampleEnd";
      params.push(this.sampleEnd);
      this.runAll.label="Run All Rows";this.runAll.jsonobject="runAll";
      params.push(this.runAll);
      this.deleteMisses.label="Delete Misses";this.deleteMisses.jsonobject="deleteMisses";
      params.push(this.deleteMisses);
      this.missName.label="Misses Named";this.missName.jsonobject="missName";
      params.push(this.missName);

    }
    // Function to create form group dynamically based on settings Initialize each field with a null value
    this.form = this.createFormGroup(params);
    this.form.statusChanges.subscribe(status => {
      this.formStatus.emit(this.form.valid);
    });
    this.form.markAllAsTouched();
  }
  isvaluechanged=true;
  ngOnChanges(changes: SimpleChanges ): void {
    if (changes['sourceColumns']) {
      if (this.isvaluechanged && this.sourceColumns) {
        this.isvaluechanged = false;
        this.viewModel.sourceColumns=this.sourceColumns.map(item=>new OptionItem(item.value,item.text));
        this.viewModel.sourceColumnsDT=this.sourceColumns;
        setTimeout(() => {
          this.setDefaultAndRemoveInvalidValues();
        }, 100);
      }
    }
  }
  createFormGroup(settings: ParameterSetting[]): FormGroup {
    const formGroupConfig = {};
    settings.filter(x=>x.iscommonparam==true && x.isvisible==true).forEach(field => {
      if(field.isrequired){
          formGroupConfig[field.jsonobject] = ['',Validators.required];
      }else{
        formGroupConfig[field.jsonobject] = ['']; // Initialize each field with a null value
      }
    });
    return this.formBuilder.group(formGroupConfig);
  }
  removeSortInfo(sortInfo: SortInfo): void {
    const index = this.viewModel.sortInfo?.indexOf(sortInfo);

    if (index >= 0) {
      this.viewModel.sortInfo?.splice(index, 1);
    }
  }
  
  showSortBuilder(): void {
    if(!this.viewModel.sortInfo){
      this.viewModel.sortInfo=[];//to work sortInfo initialize it
    }
    const dialog = this.matDialog.open(SortBuilderComponent, {
      data: {
        fields: this.viewModel.sourceColumns.map(c => c.text),
        sortItems: this.viewModel.sortInfo.map(item => ({ ...item }))//[...this.viewModel.sortInfo ?? []] // make copy of array so it doesn't edit actual list
      }
    });

    dialog.afterClosed().subscribe(result => {
      if (!result) {
        return;
      }
      const items = result.sortItems;
      this.viewModel.sortInfo = items;
      //this.viewModel.sortInfoDisplay = this.viewModel.sortInfo.map(i => `${i.sortField} (${i.sortAscending ? 'asc' : 'desc'})}`).join(',');
      this.sortCtrl.setValue(null);
    });
  }

  removeIncludeInfo(includeInfo: IncludeInfo): void {
    const index = this.viewModel.includeInResults?.indexOf(includeInfo);

    if (index >= 0) {
      this.viewModel.includeInResults?.splice(index, 1);
    }
  }
  
  showIncludeBuilder(): void {
    const dialog = this.matDialog.open(IncludeBuilderComponent, {
      data: {
        fields: this.viewModel.sourceColumns.map(c => c.text),
        includeItems: [...this.viewModel.includeInResults ?? []] // make copy of array so it doesn't edit actual list
      }
    });

    dialog.afterClosed().subscribe(result => {
      if (!result) {
        return;
      }

      const items = result.includeItems;
      this.viewModel.includeInResults = items;
      //this.viewModel.sortInfoDisplay = this.viewModel.sortInfo.map(i => `${i.sortField} (${i.sortAscending ? 'asc' : 'desc'})}`).join(',');
      this.includeCtrl.setValue(null);
    });
  }
  onSetDefaultRule(defaultfield:string):void{
    this.showConfirmDialog('', `Fill Source Field in Rules Table with Default Source Field?`, async (confirmed) => {
      if (confirmed) {
        this.SetDefaultRule.emit(defaultfield);
      }
    }); 
  }
  onToggleRunAll(event: any){
    this.viewModel.runAll=event.checked;
    this.ToggleRulesColumnDisplay.emit();
  }
  onToggleDeleteMisses(event: any){
    this.viewModel.deleteMisses=event.checked;
  }
  stringToBoolean(str: string): boolean {
    return str.toLowerCase() === 'true';
  }
  async setDefaultAndRemoveInvalidValues(): Promise<void>{
    if((this.viewModel.sampleEnd-1)==0 || isNaN(this.viewModel.sampleEnd)){//As sampleEnd is by default 0 and save it 1 except joiner and converter
      if(this.sourceColumn.isvisible){
        for(let pr of this.sourceColumn.default.split(";")){
          const foundColumn = this.viewModel.sourceColumns.find(sc => sc.value == pr);
          if(foundColumn){
            this.viewModel.sourceColumn=foundColumn.value;
            break;
          }
        }
      }
      if(this.targetColumn.isvisible){
        for(let pr of this.targetColumn.default.split(";")){
          const foundColumn = this.viewModel.targetColumns.find(sc => sc == pr);
          if(foundColumn){
            this.viewModel.targetColumn=foundColumn;
            break;
          }
        }
      }
      if(this.userColumn.isvisible){
        for(let pr of this.userColumn.default.split(";")){
          const foundColumn = this.viewModel.sourceColumns.find(sc => sc.value == pr);
          if(foundColumn){
            this.viewModel.userColumn=foundColumn.value;
            break;
          }
        }
      }
      if(this.timeColumn.isvisible){
        for(let pr of this.timeColumn.default.split(";")){
          const foundColumn = this.viewModel.sourceColumns.find(sc => sc.value == pr);
          if(foundColumn){
            this.viewModel.timeColumn=foundColumn.value;
            break;
          }
        }
      }
      const validSourceFields = this.viewModel.sourceColumns.map(item => item.text);
      if (this.sortInfo.isvisible) {
        try {
            const sorts = JSON.parse(this.sortInfo.default.replace(/'/g, '"')); // sorts: array of arrays
            // Find the first valid sort combination
            const validSortArray = sorts.find((sortArray: any[]) =>
                Array.isArray(sortArray) &&
                sortArray.every(item => validSourceFields.includes(item.sortField))
            );
            // If we found a valid one, use it; else, set to empty
            if (validSortArray) {
                this.viewModel.sortInfo = validSortArray.map((item: any) => ({
                    sortField: item.sortField,
                    sortAscending: item.sortAscending
                }));
            } else {
              const selectedNode=this.userData.getSelectedNodeDetails();
              if(selectedNode.farmtypeid==TransformType.groupAttributor){
                this.viewModel.sortInfo = [];
              }else{
                const flatSorts = sorts.flat(); // Flatten all sort arrays
                this.viewModel.sortInfo = flatSorts.map((item: any) => ({
                  sortField: item.sortField,
                  sortAscending: item.sortAscending
                }));
                // Step 3: Filter invalid sort fields
                if (Array.isArray(this.viewModel.sortInfo)) {
                  this.viewModel.sortInfo = this.viewModel.sortInfo.filter(sortItem =>
                    validSourceFields.includes(sortItem.sortField)
                  );
                }
              }
            }
        } catch (e) {
            console.error("Invalid sortInfo.default JSON", e);
            this.viewModel.sortInfo = [];
        }
      }
      if(this.includeInResults.isvisible){
        if(this.includeInResults.default!=""){
          this.viewModel.includeInResults=this.includeInResults.default.split(";").map(item =>new IncludeInfo(item));
        }
        if(this.viewModel.includeInResults){
          const allincludeFieldsExist = this.viewModel.includeInResults?.every(inc =>this.viewModel.sourceColumns.some(sc => sc.value === inc.includeField));
          if(!allincludeFieldsExist){
            this.viewModel.includeInResults = this.viewModel.includeInResults.filter(includeField => validSourceFields.includes(includeField.includeField));
          }
        }
      }
      if(this.sampleStart.isvisible){
        if(this.sampleStart.default!=""){
          this.viewModel.sampleStart=Number(this.sampleStart.default);
        }
      }
      if(this.sampleEnd.isvisible){
        if(this.sampleEnd.default!=""){
          this.viewModel.sampleEnd=Number(this.sampleEnd.default);
        }
      }
      if(this.runAll.isvisible){
        if(this.runAll.default!=""){
          this.viewModel.runAll=this.stringToBoolean(this.runAll.default);
        }
      }
      if(this.deleteMisses.isvisible){
        if(this.deleteMisses.default!=""){
          this.viewModel.deleteMisses=this.stringToBoolean(this.deleteMisses.default);
        }
      }
      if(this.missName.isvisible){
        if(this.missName.default!=""){
          this.viewModel.missName=this.missName.default;
        }
      }
    }else{
      var isvalid=true;
      if(this.viewModel.sourceColumn){
        var foundColumn = this.viewModel.sourceColumns.find(sc => sc.value == this.viewModel.sourceColumn);  
        if(!foundColumn){
          isvalid=false;
          this.viewModel.sourceColumn=undefined;
        }
      }
      if(this.viewModel.userColumn){
        var foundColumn = this.viewModel.sourceColumns.find(sc => sc.value == this.viewModel.userColumn);  
        if(!foundColumn){
          isvalid=false;
          this.viewModel.userColumn=undefined;
        }
      }
      if(this.viewModel.timeColumn){
        var foundColumn = this.viewModel.sourceColumns.find(sc => sc.value == this.viewModel.timeColumn);  
        if(!foundColumn){
          isvalid=false;
          this.viewModel.timeColumn=undefined;
        }
      }
      const validSourceFields = this.viewModel.sourceColumns.map(item => item.text);
      if(this.viewModel.sortInfo && Array.isArray(this.viewModel.sortInfo)){
        const allSortFieldsExist = this.viewModel.sortInfo?.every(srt =>this.viewModel.sourceColumns.some(sc => sc.value === srt.sortField));
        if(!allSortFieldsExist){
          isvalid=false;
          this.viewModel.sortInfo = this.viewModel.sortInfo.filter(sortItem => validSourceFields.includes(sortItem.sortField));
        }
      }
      if(this.viewModel.includeInResults){
        const allincludeFieldsExist = this.viewModel.includeInResults?.every(inc =>this.viewModel.sourceColumns.some(sc => sc.value === inc.includeField));
        if(!allincludeFieldsExist){
          isvalid=false;
          this.viewModel.includeInResults = this.viewModel.includeInResults.filter(includeField => validSourceFields.includes(includeField.includeField));
        }
      }
      if(!isvalid){
        this.displayWarning("One or more fields in the configuration are  not in the input farm.","Warning.");
      }
    }
  }
  onEventTimeColumn(){
    this.eventTimeColumn.emit();
  }
  get sourceColumnsOptions(): string[] {
    return this.sourceColumns?.map(item => item.text) || [];
  }
  get targetColumnsOptions(): string[] {
    return this.viewModel.targetColumns || [];
  }
  get sourceColumnsOptionsString(): string[] {
    return this.viewModel.sourceColumnsDT?.filter(col=>this.getNormalizedDataType(col.dataType)=="string").map(item => item.text) || [];
  }
  get sourceColumnsOptionsTimeStamp(): string[] {
    return this.viewModel.sourceColumnsDT?.filter(col=>this.getNormalizedDataType(col.dataType)=="datetime").map(item => item.text) || [];
  }
}
